/* global axios */
import ApiClient from './ApiClient';

class WhatsappBillingAPI extends ApiClient {
  constructor() {
    super('whatsapp_billing', { accountScoped: true });
  }

  get(inboxId = null) {
    const params = inboxId ? { inbox_id: inboxId } : {};
    return axios.get(this.url, { params });
  }
}

export default new WhatsappBillingAPI();
